import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Add symbols to watchlist")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_TheWatchSymbolButton = _resolveComponent("TheWatchSymbolButton")
  const _component_SymbolList = _resolveComponent("SymbolList")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "addtowatchlist_2" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_SymbolList, {
        onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save')))
      }, {
        default: _withCtx(({symbol}) => [
          _createVNode(_component_TheWatchSymbolButton, { "market-item": symbol }, null, 8, ["market-item"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}